'use strict';

var React = require('react');
var ClassNames = require('classnames');
var ReactSelect = require('react-select');
var InlineError = require('../Common/InlineError.jsx');
var InlineMessage = require('./InlineMessage.jsx');
var InlineInfoMessage = require('./InlineInfoMessage.jsx');
var InlineInfoButton = require('./InlineInfoButton.jsx');
var _ = require('lodash');
var Spinner = require('./Spinner.jsx');

var SelectInput = React.createClass({
    getInitialState: function () {
        return {
            hideHelpText: true,
            value: this.props.value
        };
    },

    propTypes: {
        label: React.PropTypes.string,
        id: React.PropTypes.string.isRequired,
        placeholder: React.PropTypes.string,
        clearable: React.PropTypes.bool,
        searchable: React.PropTypes.bool,
        value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
        onChange: React.PropTypes.func,
        onBlur: React.PropTypes.func,
        isValid: React.PropTypes.bool,
        errorHeading: React.PropTypes.string,
        errorMessage: React.PropTypes.string,
        customClass: React.PropTypes.string,
        isHidden: React.PropTypes.bool,
        helpText: React.PropTypes.string,
        copyText: React.PropTypes.string,
        focusedOption: React.PropTypes.string,
        model: React.PropTypes.string,
        options: React.PropTypes.array.isRequired,
        size: React.PropTypes.string,
        hideSpinner: React.PropTypes.bool,
        mandatory: React.PropTypes.bool,
        disabled: React.PropTypes.bool,
        notes: React.PropTypes.string,
        multi: React.PropTypes.bool
    },
    getDefaultProps: function () {
        return {
            isValid: true,
            isHidden: false,
            searchable: true,
            hasWarning: false,
            helpText: '',
            size: 'lg',
            placeholder: 'Select',
            mandatory: true,
            disabled: false,
            multi: false
        };
    },
    _changeValue: function (value) {
       if (this.props.onChange) {
            this.props.onChange({ target: { model: this.props.model, id: this.props.id, value: value } });
        }       
    },
    _handleReactSelectOnChange: function(value){
        if(value){
            this._changeValue(value);
        }
        else {
            if (this.props.backspaceRemoves) {
                this._changeValue('');
            }
            this.setState({ value: value });
        }
    },
    //when using select input as a predictive search, use onBlur as the change/update event
    _handleOnChange: function (event){
        this._changeValue(event.target.value);
    },
    _handleOnBlur: function () {
        // FIXME: This breaks functionality in some pages
        //Use onBlur to save only when the value is empty; otherwise onChange is used for saving data
        if (!this.props.noRequiredValidation && !this.state.value) {
            this._changeValue(this.state.value);
        }
    },
    toggleShowHideHelpText: function () {
        this.setState({
            hideHelpText: !this.state.hideHelpText
        });
    },

    componentWillReceiveProps: function (nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value });  //update internal state
        }
    },

    inlineErrorMessage: function () {
        var errorMessage = null;
        //if errorList is passed, use it otherwise use errorHeading / errorText
        if (this.props.errorList) {
            var errorOfTheField = _.filter(this.props.errorList, { id: this.props.id });
            if (errorOfTheField.length > 0 && errorOfTheField[0]) {
                errorMessage = (<InlineMessage key={this.props.key}
                                               id={'inline-message-' + this.props.id}
                                               isHidden={!errorOfTheField[0].message}
                                               type={errorOfTheField[0].type}
                                               message={errorOfTheField[0].message} />);
            }
        } else if(this.props.isValid) {
            return null;
        }
        else {
            errorMessage = <InlineError className="alert alert-warning"
                                        isHideError={this.props.errorList || this.props.isValid}
                                        header={this.props.errorHeading || 'Invalid ' + this.props.label}
                                        message={this.props.errorMessage} />;
        }
        return errorMessage;
    },

    render: function () {
        var component = '';
        var rightText = !this.props.mandatory ? <span className="optional optional-select-input">optional</span> : null;

        if (this.props.searchable) {
            const size = 'select-input-' + this.props.size;
            component = <span>
                        <ReactSelect className={ClassNames(size, this.props.className)}
                                     name={this.props.id}
                                     options={this.props.options}
                                     placeholder={this.props.placeholder}
                                     clearable={this.props.clearable}
                                     searchable={this.props.searchable}
                                     focusedOption={this.props.focusedOption}
                                     disabled={this.props.disabled}
                                     backspaceRemoves={this.props.backspaceRemoves}
                                     value={this.state.value}
                                     onChange={this._handleReactSelectOnChange}
                                     onBlur={this._handleOnBlur}
                                     inputProps={_.assign({ id: this.props.id }, this.props.inputProps)}
                                     filterOptions={this.props.filterOptions}
                                     multi = {this.props.multi} />{rightText}</span>;
        } else {
            component = <div className="form-control-select"><select id={this.props.id}
                                className={ClassNames('btn btn-default btn-lg normal-select-input', {'select-placeholder': !this.state.value}, this.props.className)}
                                disabled={this.props.disabled}
                                value={this.state.value}
                                onBlur={this._handleOnBlur}
                                onChange={this._handleOnChange}>
                                {this.props.placeholder ? <option value="" className="hidden">{this.props.placeholder}</option> : null}
                                {this.props.options.map(function (data, index) {
                                    return (<option key={index} value={data.value }>{data.label}</option>);
                                })}
                        </select>{rightText}</div>;
        }

        var label = this.props.label ? <div className="form-label-section">
                                            <label htmlFor={this.props.id }>{this.props.label}</label>
                                            <InlineInfoButton helpText={this.props.helpText} isHidden={this.state.hideHelpText} toggleShowHideHelpText={this.toggleShowHideHelpText} />
                                        </div>
                                     : null;
        var notes = this.props.notes ? <div className="form-label-section">
                                           <p>{this.props.notes}</p>
                                        </div>
                                    : null;
        var errorMessage = this.inlineErrorMessage();
        var hideSpinner = this.props.hideSpinner ? this.props.hideSpinner : this.props.options && this.props.options.length > 0;
        
        return (
            <div id={this.props.id} className={ClassNames('form-section', {'has-warning': errorMessage || this.props.hasWarning === true}, this.props.customClass, { hidden: this.props.isHidden })}>
                {label}
                <InlineInfoMessage isHidden={this.state.hideHelpText} message={this.props.helpText} />
                {(this.props.copyText) ? <p dangerouslySetInnerHTML={{ __html: this.props.copyText } } /> : null}
                {hideSpinner ? component : (<Spinner customClass="left-spinner"/>)}
                {errorMessage}
                {notes}
            </div>
        );
    }
});
module.exports = SelectInput;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/SelectInput.jsx